import React from 'react';
import { motion } from 'framer-motion';
import { FaNewspaper, FaUser, FaCalendar, FaTag } from 'react-icons/fa';

const BlogPage: React.FC = () => {
  const blogPosts = [
    {
      title: 'Impact of Tree Plantation on Urban Environment',
      excerpt: 'How our tree plantation drives are helping combat air pollution and urban heat islands in major cities.',
      author: 'Dr. Rajesh Kumar',
      date: 'May 15, 2026',
      category: 'Environment',
      readTime: '5 min read'
    },
    {
      title: 'Success Story: From Scholarship to Software Engineer',
      excerpt: 'The inspiring journey of Priya, who went from receiving our scholarship to becoming a successful software engineer.',
      author: 'Ms. Neha Sharma',
      date: 'May 10, 2026',
      category: 'Education',
      readTime: '4 min read'
    },
    {
      title: 'Emergency Response: Flood Relief in Assam',
      excerpt: 'How our natural disaster relief team provided immediate assistance to flood-affected communities in Assam.',
      author: 'Mr. Amit Patel',
      date: 'April 28, 2026',
      category: 'Natural Disaster Relief',
      readTime: '6 min read'
    },
    {
      title: 'Sustainable Agriculture: Our Organic Farming Initiative',
      excerpt: 'Learn about our sustainable farming methods that are empowering rural communities.',
      author: 'Mr. Ravi Verma',
      date: 'April 20, 2026',
      category: 'Agriculture',
      readTime: '7 min read'
    },
    {
      title: 'Legal Aid: Empowering Marginalized Communities',
      excerpt: 'How our free legal consultation services are helping underprivileged families access justice.',
      author: 'Adv. Sunita Reddy',
      date: 'April 15, 2026',
      category: 'Legal Aid',
      readTime: '5 min read'
    },
    {
      title: 'Meditation and Mental Wellness: Research Findings',
      excerpt: 'Latest research on the benefits of meditation for stress management and mental health.',
      author: 'Dr. Anil Kapoor',
      date: 'April 10, 2026',
      category: 'Wellness',
      readTime: '8 min read'
    }
  ];

  return (
    <div className="blog-page">
      <section className="bg-gradient-to-r from-primary-teal to-primary-green py-20">
        <div className="container-lg px-4 text-center text-white">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Blog & News</h1>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              Stay updated with our latest activities, success stories, and insights into social welfare.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-lg px-4">
          <h2 className="text-3xl font-bold mb-8">Latest Articles</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <div className="p-6">
                  <div className="flex items-center text-primary-green mb-3">
                    <span className="mr-2"><FaTag /></span>
                    <span className="font-semibold">{post.category}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-4">{post.title}</h3>
                  
                  <p className="text-gray-600 mb-6">{post.excerpt}</p>
                  
                  <div className="flex items-center justify-between text-sm text-gray-500 mb-6">
                    <div className="flex items-center">
                      <span className="mr-2"><FaUser /></span>
                      <span>{post.author}</span>
                    </div>
                    <div className="flex items-center">
                      <span className="mr-2"><FaCalendar /></span>
                      <span>{post.date}</span>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500 text-sm">{post.readTime}</span>
                    <button className="text-primary-green font-semibold hover:text-primary-darkgreen">
                      Read More →
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;